import { useRoute, useRouter } from '#imports';

export function useQueryParams() {
  const queryParamsStore = useQueryParamsStore();
  const route = useRoute();
  const router = useRouter();

  // Extract query params from the current route
  const captureQueryParams = async () => {
    const queryParams = { ...route.query }
    if(queryParams && !_isEmpty(queryParams)) {
      queryParamsStore.setQueryParams(queryParams as Record<string, string>);
      storeAgentInfo(queryParams as Record<string, string>);
    } else {
      // clear query params store
      useAgentInfoStore().reset()
      useQueryParamsStore().reset()
    }
  };

  async function storeAgentInfo(queryParams: Record<string, string>) {
    const agentId = getIgnoreCase(queryParams, "agent", "")
    const storedAgentId = useAgentInfoStore().insuranceAgent?.identifier || ""
    const agentCompany = getIgnoreCase(queryParams, "company", "")
    if(agentId && agentId.toUpperCase() !== storedAgentId.toUpperCase()) {
      fetch(`/webapi/agents/${agentId.toUpperCase()}`).then(async response => {
        const agentInfo = await response.json();
        if(_get(agentInfo, "id")) {
          agentInfo.properties.agent_url_slug = agentId
          if(agentCompany) {
            agentInfo.properties.company_url_slug = agentCompany
          }
          useAgentInfo().setAgentInfoInStore(agentInfo);
          useContactInfoStore().setContactAgentInfo(agentInfo.properties)
        } else {
          useAgentInfoStore().reset()
          useQueryParamsStore().reset()
        }
      }).catch(error => {
        useAgentInfoStore().reset()
        useQueryParamsStore().reset()
      })
    }
  }

  // Initialize and load stored params from session storage if available
  const loadStoredQueryParams = () => {
    let queryParams = useQueryParamsStore().queryParams
    if(isProxy(queryParams)) {
      queryParams = toRaw(queryParams);
    }
    if (Object.keys(queryParams).length > 0) {
      // Optionally sync the stored params with the current route
      router.replace({ query: queryParams });
    }
  };

  // Sync on route change
  const syncQueryParamsOnNavigate = () => {
    watch(
      () => route.query,
      (newQuery) => {
        captureQueryParams();
      },
      { immediate: true }
    );
  };

  function getIgnoreCase<T>(object: Record<string, any> | null, path: string | string[], defaultValue: T): T | any {
    if (!object) return defaultValue;

    const paths = Array.isArray(path) ? path : path.split('.');
    let current: any = object;

    for (const key of paths) {
      if (current) {
        const lowerKey = String(key).toLowerCase();
        const foundKey = Object.keys(current).find(k => k.toLowerCase() === lowerKey);

        if (foundKey) {
          current = current[foundKey];
        } else {
          return defaultValue;
        }
      } else {
        return defaultValue;
      }
    }

    return current;
  }

  return { captureQueryParams, loadStoredQueryParams, syncQueryParamsOnNavigate };
}
